<template>
  <b-row>
    <b-col sm="5" class="form-label">
      <i :class="[icon, 'fax']"></i>
      <label>{{ label }}</label>
    </b-col>
    <b-col sm="6">
      <b-form-input
              size="sm"
              :disabled="true"
              :value="value"
      />
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [ String, Number ],
      default: ''
    },
    icon: {
      type: String,
      default: 'fad fa-user-tag'
    },
  }
}
</script>